import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import logo from "@/assets/logo.png";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== confirm) { toast.error("Passwords do not match"); return; }
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset successfully. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-white">
      <div className="w-full max-w-sm">
        <Link to="/" className="inline-flex items-center gap-2 mb-10" data-testid="brand-link">
          <img src={logo} alt="Pranav Anand Enterprises" className="h-14 w-auto object-contain"/>
          <span className="font-heading font-semibold text-base" style={{color:"#0e5a32"}}>Pranav Anand Enterprises</span>
        </Link>
        <h1 className="text-3xl font-heading font-semibold tracking-tight mb-2" data-testid="reset-title">Set a new password</h1>
        {!token ? (
          <p className="text-sm text-red-600 mb-8" data-testid="reset-no-token">This reset link is missing its token. Please use the link from your email or request a new one.</p>
        ) : (
          <>
            <p className="text-sm text-gray-500 mb-8">Choose a new password for your account.</p>
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <Label htmlFor="pw" className="text-xs font-medium uppercase tracking-wider text-gray-600">New password</Label>
                <Input id="pw" data-testid="reset-password" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="rounded-sm mt-1"/>
              </div>
              <div>
                <Label htmlFor="confirm" className="text-xs font-medium uppercase tracking-wider text-gray-600">Confirm new password</Label>
                <Input id="confirm" data-testid="reset-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="rounded-sm mt-1"/>
              </div>
              <Button type="submit" disabled={submitting} data-testid="reset-submit" className="w-full bg-[#002fa7] hover:bg-[#00227b] rounded-sm">
                {submitting ? "Resetting…" : "Reset password"}
              </Button>
            </form>
          </>
        )}
        <p className="text-sm text-gray-500 mt-6">
          <Link to="/login" className="text-[#002fa7] font-medium hover:underline" data-testid="reset-to-login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
